import React, { useContext, useEffect, useState } from 'react';
import { getErrorMessage } from '../utils/errorHandler';
import axios from 'axios';
import Navbar from '../components/Navbar';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Checkbox } from '../components/ui/checkbox';
import { toast } from 'sonner';
import { Separator } from '../components/ui/separator';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import ProfilePhotoCropModal from '../components/ProfilePhotoCropModal';
import { AuthContext } from '../App';

// Lista prefissi internazionali più comuni
const PHONE_PREFIXES = [
  { code: '+39', country: 'Italia', flag: '🇮🇹' },
  { code: '+1', country: 'USA/Canada', flag: '🇺🇸' },
  { code: '+44', country: 'Regno Unito', flag: '🇬🇧' },
  { code: '+33', country: 'Francia', flag: '🇫🇷' },
  { code: '+49', country: 'Germania', flag: '🇩🇪' },
  { code: '+34', country: 'Spagna', flag: '🇪🇸' },
  { code: '+41', country: 'Svizzera', flag: '🇨🇭' },
  { code: '+43', country: 'Austria', flag: '🇦🇹' },
  { code: '+31', country: 'Paesi Bassi', flag: '🇳🇱' },
  { code: '+32', country: 'Belgio', flag: '🇧🇪' },
  { code: '+351', country: 'Portogallo', flag: '🇵🇹' },
  { code: '+30', country: 'Grecia', flag: '🇬🇷' },
  { code: '+93', country: 'Afghanistan', flag: '🇦🇫' },
  { code: '+355', country: 'Albania', flag: '🇦🇱' },
  { code: '+213', country: 'Algeria', flag: '🇩🇿' },
  { code: '+244', country: 'Angola', flag: '🇦🇴' },
  { code: '+54', country: 'Argentina', flag: '🇦🇷' },
  { code: '+374', country: 'Armenia', flag: '🇦🇲' },
  { code: '+61', country: 'Australia', flag: '🇦🇺' },
  { code: '+994', country: 'Azerbaigian', flag: '🇦🇿' },
  { code: '+973', country: 'Bahrein', flag: '🇧🇭' },
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩' },
  { code: '+375', country: 'Bielorussia', flag: '🇧🇾' },
  { code: '+591', country: 'Bolivia', flag: '🇧🇴' },
  { code: '+387', country: 'Bosnia-Erzegovina', flag: '🇧🇦' },
  { code: '+267', country: 'Botswana', flag: '🇧🇼' },
  { code: '+55', country: 'Brasile', flag: '🇧🇷' },
  { code: '+673', country: 'Brunei', flag: '🇧🇳' },
  { code: '+359', country: 'Bulgaria', flag: '🇧🇬' },
  { code: '+226', country: 'Burkina Faso', flag: '🇧🇫' },
  { code: '+257', country: 'Burundi', flag: '🇧🇮' },
  { code: '+855', country: 'Cambogia', flag: '🇰🇭' },
  { code: '+237', country: 'Camerun', flag: '🇨🇲' },
  { code: '+238', country: 'Capo Verde', flag: '🇨🇻' },
  { code: '+236', country: 'Repubblica Centrafricana', flag: '🇨🇫' },
  { code: '+235', country: 'Ciad', flag: '🇹🇩' },
  { code: '+56', country: 'Cile', flag: '🇨🇱' },
  { code: '+86', country: 'Cina', flag: '🇨🇳' },
  { code: '+57', country: 'Colombia', flag: '🇨🇴' },
  { code: '+269', country: 'Comore', flag: '🇰🇲' },
  { code: '+242', country: 'Congo', flag: '🇨🇬' },
  { code: '+243', country: 'Repubblica Democratica del Congo', flag: '🇨🇩' },
  { code: '+225', country: 'Costa d’Avorio', flag: '🇨🇮' },
  { code: '+506', country: 'Costa Rica', flag: '🇨🇷' },
  { code: '+53', country: 'Cuba', flag: '🇨🇺' },
  { code: '+357', country: 'Cipro', flag: '🇨🇾' },
  { code: '+45', country: 'Danimarca', flag: '🇩🇰' },
  { code: '+20', country: 'Egitto', flag: '🇪🇬' },
  { code: '+503', country: 'El Salvador', flag: '🇸🇻' },
  { code: '+291', country: 'Eritrea', flag: '🇪🇷' },
  { code: '+372', country: 'Estonia', flag: '🇪🇪' },
  { code: '+251', country: 'Etiopia', flag: '🇪🇹' },
  { code: '+679', country: 'Figi', flag: '🇫🇯' },
  { code: '+358', country: 'Finlandia', flag: '🇫🇮' },
  { code: '+220', country: 'Gambia', flag: '🇬🇲' },
  { code: '+995', country: 'Georgia', flag: '🇬🇪' },
  { code: '+233', country: 'Ghana', flag: '🇬🇭' },
  { code: '+502', country: 'Guatemala', flag: '🇬🇹' },
  { code: '+224', country: 'Guinea', flag: '🇬🇳' },
  { code: '+240', country: 'Guinea Equatoriale', flag: '🇬🇶' },
  { code: '+592', country: 'Guyana', flag: '🇬🇾' },
  { code: '+509', country: 'Haiti', flag: '🇭🇹' },
  { code: '+504', country: 'Honduras', flag: '🇭🇳' },
  { code: '+852', country: 'Hong Kong', flag: '🇭🇰' },
  { code: '+36', country: 'Ungheria', flag: '🇭🇺' },
  { code: '+91', country: 'India', flag: '🇮🇳' },
  { code: '+62', country: 'Indonesia', flag: '🇮🇩' },
  { code: '+98', country: 'Iran', flag: '🇮🇷' },
  { code: '+964', country: 'Iraq', flag: '🇮🇶' },
  { code: '+353', country: 'Irlanda', flag: '🇮🇪' },
  { code: '+972', country: 'Israele', flag: '🇮🇱' },
  { code: '+81', country: 'Giappone', flag: '🇯🇵' },
  { code: '+962', country: 'Giordania', flag: '🇯🇴' },
  { code: '+7', country: 'Federazione Russa', flag: '🇷🇺' },
  { code: '+90', country: 'Turchia', flag: '🇹🇷' },
  { code: '+380', country: 'Ucraina', flag: '🇺🇦' },
  { code: '+263', country: 'Zimbabwe', flag: '🇿🇼' }
];

// Regex per validazione LinkedIn URL
const LINKEDIN_REGEX = /^https?:\/\/(www\.)?(linkedin\.com|it\.linkedin\.com)\/(in|pub|company)\/[A-Za-z0-9_-]+\/?$/;
const CHECKBOX_TO_BOOL = (value) => value === true;
const parseNumericValue = (value) => {
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};
const INITIAL_FORM_DATA = {
  first_name: '',
  last_name: '',
  email: '',
  phone_prefix: '+39',
  phone: '',
  country_id: null,
  province_id: null,
  city_id: null,
  city_strgin: '',
  company_name: '',
  job_title: '',
  utente_invitato_da: '',
  job_category_id: null,
  company_sector_id: null,
  linkedin_url: '',
  documents_accepted: false,
  privacy_accepted: false
};
const isValidPhone = (value) => {
  const digits = (value || '').replace(/\D/g, '');
  return digits.length >= 6 && digits.length <= 15;
};
const isValidEmail = (value) => /\S+@\S+\.\S+/.test(value || '');

export default function RegolamentoPage() {
  const { user } = useContext(AuthContext);
  const [documents, setDocuments] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);

  // Geographic data
  const [countries, setCountries] = useState([]);
  const [jobCategories, setJobCategories] = useState([]);
  const [companySectors, setCompanySectors] = useState([]);

  // LinkedIn validation
  const [linkedinError, setLinkedinError] = useState('');
  const [cv, setCv] = useState(null);
  const [motivationLetter, setMotivationLetter] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [profilePhotoPreviewUrl, setProfilePhotoPreviewUrl] = useState('');
  const [rawProfilePhotoFile, setRawProfilePhotoFile] = useState(null);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpCode, setOtpCode] = useState('');
  const [sendingOtp, setSendingOtp] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [phoneOtpId, setPhoneOtpId] = useState(null);
  const [existingUserId, setExistingUserId] = useState(null);
  const [blockedMessage, setBlockedMessage] = useState('');

  // Email verification
  const [emailVerified, setEmailVerified] = useState(false);
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [emailOtpCode, setEmailOtpCode] = useState('');
  const [sendingEmailOtp, setSendingEmailOtp] = useState(false);
  const [verifyingEmailOtp, setVerifyingEmailOtp] = useState(false);
  const [emailOtpId, setEmailOtpId] = useState(null);

  useEffect(() => {
    fetchDocuments();
    fetchCountries();
    fetchJobCategories();
    fetchCompanySectors();
  }, []);

  useEffect(() => {
    if (!profilePhoto) {
      setProfilePhotoPreviewUrl('');
      return undefined;
    }
    const previewUrl = URL.createObjectURL(profilePhoto);
    setProfilePhotoPreviewUrl(previewUrl);
    return () => {
      URL.revokeObjectURL(previewUrl);
    };
  }, [profilePhoto]);

  const fetchDocuments = async () => {
    try {
      const response = await axios.get('/documents');
      setDocuments(response.data);
    } catch (error) {
      console.error('Failed to fetch documents', error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await axios.get('/public/countries');
      setCountries(response.data);
      // Auto-select Italia if available
      const italia = response.data.find(c => c.code === 'IT');
      if (italia) {
        setFormData(prev => ({ ...prev, country_id: italia.id }));
      }
    } catch (error) {
      console.error('Failed to fetch countries', error);
    }
  };

  const fetchJobCategories = async () => {
    try {
      const response = await axios.get('/public/job-categories');
      setJobCategories(response.data);
    } catch (error) {
      console.error('Failed to fetch job categories', error);
    }
  };

  const fetchCompanySectors = async () => {
    try {
      const response = await axios.get('/public/company-sectors');
      setCompanySectors(response.data);
    } catch (error) {
      console.error('Failed to fetch company sectors', error);
    }
  };

  const handleCountryChange = (countryId) => {
    const parsed = parseNumericValue(countryId);
    setFormData(prev => ({ ...prev, country_id: parsed, province_id: null, city_id: null }));
  };

  const validateLinkedInUrl = (url) => {
    if (!url) {
      setLinkedinError('');
      return true;
    }
    if (LINKEDIN_REGEX.test(url)) {
      setLinkedinError('');
      return true;
    } else {
      setLinkedinError('URL LinkedIn non valido. Formato: https://linkedin.com/in/nomeutente');
      return false;
    }
  };

  const getDocument = (type) => {
    return documents.find(doc => doc.doc_type === type);
  };

  const prefillFromExistingUser = async (data) => {
    const toNullableNumber = (value) => (value === null || value === undefined ? null : Number(value));
    setFormData((prev) => ({
      ...prev,
      first_name: data.first_name || '',
      last_name: data.last_name || '',
      email: data.email || '',
      country_id: toNullableNumber(data.country_id),
      province_id: toNullableNumber(data.province_id),
      city_id: toNullableNumber(data.city_id),
      city_strgin: data.city_strgin || data.city || '',
      company_name: data.company_name || '',
      job_title: data.job_title || '',
      utente_invitato_da: data.utente_invitato_da || '',
      job_category_id: toNullableNumber(data.job_category_id),
      company_sector_id: toNullableNumber(data.company_sector_id),
      linkedin_url: data.linkedin_url || ''
    }));
  };

  const handleSendOTP = async () => {
    const phone = formData.phone.trim();
    if (!isValidPhone(phone)) {
      toast.error('Inserisci un numero di telefono valido');
      return;
    }

    setFormData((prev) => ({ ...prev, phone }));
    setSendingOtp(true);
    try {
      await axios.post('/public/application/verify-phone', {
        phone_prefix: formData.phone_prefix,
        phone_number: phone
      });
      setOtpSent(true);
      setOtpCode('');
      setPhoneVerified(false);
      setBlockedMessage('');
      setPhoneOtpId(null);
      setExistingUserId(null);
      toast.success('Codice OTP inviato al tuo telefono');
    } catch (error) {
      toast.error(getErrorMessage(error, 'Errore nell\'invio del codice OTP'));
    } finally {
      setSendingOtp(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (!otpCode || otpCode.length !== 6) {
      toast.error('Inserisci il codice a 6 cifre');
      return;
    }

    setVerifyingOtp(true);
    try {
      const response = await axios.post('/public/application/verify-otp', {
        phone_prefix: formData.phone_prefix,
        phone_number: formData.phone,
        otp_code: otpCode
      });

      const result = response.data || {};
      if (result.blocked || result.eligible === false) {
        setBlockedMessage(result.message || 'Non è possibile inviare la candidatura per questo utente, candidatura già inviata oppure utente già associato');
        setPhoneVerified(false);
        setPhoneOtpId(null);
        setExistingUserId(null);
        return;
      }

      setPhoneVerified(true);
      setPhoneOtpId(result.phone_otp_id || null);
      setExistingUserId(result.user_id || null);
      setBlockedMessage('');

      if (result.existing_user) {
        await prefillFromExistingUser(result);
        toast.success('Telefono verificato. Dati precompilati caricati.');
      } else {
        toast.success('Telefono verificato con successo');
      }
    } catch (error) {
      toast.error(getErrorMessage(error, 'Codice OTP non valido'));
    } finally {
      setVerifyingOtp(false);
    }
  };

  const handleSendEmailOTP = async () => {
    const email = formData.email.trim();
    if (!isValidEmail(email)) {
      toast.error('Inserisci una email valida');
      return;
    }

    setFormData(prev => ({ ...prev, email }));

    setSendingEmailOtp(true);
    try {
      const response = await axios.post('/public/application/send-email-otp', {
        email
      });
      setEmailOtpSent(true);
      setEmailOtpId(response.data?.otp_id || null);
      toast.success('Codice OTP inviato alla tua email!');
    } catch (error) {
      toast.error(getErrorMessage(error, 'Errore nell\'invio del codice OTP'));
    } finally {
      setSendingEmailOtp(false);
    }
  };

  const handleVerifyEmailOTP = async () => {
    if (!emailOtpCode || emailOtpCode.length !== 6) {
      toast.error('Inserisci il codice a 6 cifre');
      return;
    }

    setVerifyingEmailOtp(true);
    try {
      const response = await axios.post('/public/application/verify-email-otp', {
        email: formData.email,
        otp_code: emailOtpCode
      });
      setEmailOtpId(response.data?.email_otp_id || emailOtpId);
      setEmailVerified(true);
      toast.success('Email verificata con successo!');
    } catch (error) {
      toast.error(getErrorMessage(error, 'Codice OTP non valido'));
    } finally {
      setVerifyingEmailOtp(false);
    }
  };

  const resetFormState = () => {
    setFormData(INITIAL_FORM_DATA);
    setCv(null);
    setMotivationLetter(null);
    setProfilePhoto(null);
    setRawProfilePhotoFile(null);
    setCropModalOpen(false);
    setPhoneVerified(false);
    setOtpSent(false);
    setOtpCode('');
    setPhoneOtpId(null);
    setExistingUserId(null);
    setBlockedMessage('');
    setEmailVerified(false);
    setEmailOtpSent(false);
    setEmailOtpCode('');
    setEmailOtpId(null);
    setLinkedinError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phoneVerified || !phoneOtpId) {
      toast.error('Devi verificare il numero di telefono');
      return;
    }

    if (!emailVerified || !emailOtpId) {
      toast.error('Devi verificare la tua email');
      return;
    }

    if (!formData.documents_accepted) {
      toast.error('Devi accettare i documenti BASE');
      return;
    }

    if (!formData.privacy_accepted) {
      toast.error('Devi accettare l\'Informativa Privacy');
      return;
    }

    if (!cv || !motivationLetter) {
      toast.error('CV e Lettera motivazionale sono obbligatori');
      return;
    }

    if (!profilePhoto) {
      toast.error('La foto profilo è obbligatoria');
      return;
    }

    if (!formData.job_category_id) {
      toast.error('Categoria lavorativa obbligatoria');
      return;
    }

    if (!formData.company_sector_id) {
      toast.error('Settore azienda obbligatorio');
      return;
    }
    if (!String(formData.city_strgin || '').trim()) {
      toast.error('Città obbligatoria');
      return;
    }
    if (!String(formData.utente_invitato_da || '').trim()) {
      toast.error('Il campo "Utente invitato da" è obbligatorio');
      return;
    }

    if (formData.linkedin_url && !validateLinkedInUrl(formData.linkedin_url)) {
      return;
    }

    setSubmitting(true);

    try {
      const submitData = new FormData();
      Object.keys(formData).forEach(key => {
        if (formData[key] !== null && formData[key] !== '') {
          submitData.append(key, formData[key]);
        }
      });
      if (existingUserId) {
        submitData.append('user_id', existingUserId);
      }
      submitData.append('phone_otp_id', phoneOtpId);
      submitData.append('email_otp_id', emailOtpId);
      submitData.append('profile_photo', profilePhoto);
      submitData.append('cv', cv);
      submitData.append('motivation_letter', motivationLetter);

      await axios.post('/public/application/submit', submitData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      toast.success('Candidatura inviata con successo! La tua richiesta sarà esaminata.');
      resetFormState();
      setShowForm(false);
    } catch (error) {
      toast.error(getErrorMessage(error, 'Errore nell\'invio della candidatura'));
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleProfilePhotoInputChange = (event) => {
    const selectedFile = event.target.files?.[0] || null;
    event.target.value = '';
    if (!selectedFile) {
      return;
    }
    setRawProfilePhotoFile(selectedFile);
    setCropModalOpen(true);
  };

  const handleProfilePhotoCropConfirm = (croppedFile) => {
    setProfilePhoto(croppedFile);
    setRawProfilePhotoFile(null);
    setCropModalOpen(false);
    toast.success('Foto profilo pronta');
  };

  return (
    <div className="min-h-screen bg-white" data-testid="regolamento-page">
      <Navbar />

      <div className="pt-20 p-6 max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-testid="page-title">Regolamento di ammissione ed esclusione dei soci</h1>
        </div>

        {/* Regolamento Content */}
        <div className="mb-8" data-testid="regolamento-content">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Regolamento</h2>
          <p className="text-gray-700 leading-relaxed mb-6 whitespace-pre-wrap">
            <section>
              <h2><strong>Art. 1 – Ammissione dei nuovi soci</strong></h2>
              <p><strong>1.1</strong> L’ammissione di nuovi associati avviene su invito da parte dell’Associazione, dietro presentazione da parte di un associato ovvero su proposta del candidato.</p>
              <p><strong>1.2</strong> Il Consiglio Direttivo dell’Associazione può individuare candidati in possesso dei requisiti di partecipazione, che rispettino i princìpi del Codice Etico, da invitare ad aderire a Base. Per i candidati così individuati non è previsto che l’Assemblea generale o i singoli associati, anche al di fuori della convocazione dell’Assemblea, votino sull’invito.</p>
              <p><strong>1.3</strong> Ogni associato ha diritto di proporre al Consiglio Direttivo l’adesione di un nuovo candidato. Il Consiglio Direttivo, verificato che non esistano motivi di incompatibilità del candidato con i valori e gli scopi dell’Associazione, ne sottopone la candidatura agli associati secondo le modalità descritte dall’Allegato A.</p>
              <p><strong>1.4</strong> Chiunque voglia sottoporre la propria candidatura all’Associazione ne ha diritto secondo le modalità indicate dall’Allegato A al presente regolamento. La candidatura deve contenere le informazioni richieste a pena di inammissibilità. Ogni candidatura è sottoposta al Consiglio Direttivo, che valuta eventuali profili di incompatibilità con i valori e gli scopi dell’Associazione. Se la candidatura è ammissibile, questa viene sottoposta al voto degli associati secondo le modalità indicate nell’Allegato A al presente regolamento.</p>
              <p><strong>1.5</strong> Votata l’ammissione di un nuovo candidato, l’adesione è formalizzata dopo un periodo di prova di sei mesi. Durante il periodo di prova il candidato ha uno status equiparato a quello degli associati quanto a diritti e doveri; non ha tuttavia diritto di voto nell’Assemblea ordinaria dei soci ed è esentato dal versamento della quota associativa annuale.</p>
            </section>

            <br></br>

            <section>
              <h2><strong>Art. 2 – Recesso dell’associato</strong></h2>
              <p><strong>2.1</strong> Ai sensi dell’art. 24, comma 2, cod. civ., ogni associato ha diritto di recedere dall’Associazione se non ha assunto l’obbligo di farne parte per un tempo determinato. La dichiarazione di recesso deve essere comunicata per iscritto al Consiglio Direttivo e ha effetto con lo scadere dell’anno in corso, purché sia fatta con un preavviso di almeno tre mesi.</p>
              <p><strong>2.2</strong> Per ragioni, anche non gravi, proposte dall’associato che intende esercitare il proprio diritto di recesso, il Consiglio Direttivo può accogliere la domanda di recesso senza il preavviso prescritto dalla legge e dal presente regolamento, deliberare l’avvenuto recesso o indicare un nuovo termine a decorrere dal quale cessa lo status di associato.</p>
            </section>

            <br></br>

            <section>
              <h2><strong>Art. 3 – Esclusione</strong></h2>
              <p><strong>3.1</strong> Il Consiglio Direttivo di Base delibera, a maggioranza assoluta dei suoi componenti, ai sensi e per gli effetti dell’art. 24 cod. civ., l’esclusione dell’associato.</p>
              <p><strong>3.2</strong> L’esclusione dell’associato è deliberata per gravi motivi. Costituiscono, tra gli altri, gravi motivi tali da giustificare l’esclusione: le violazioni del Codice Etico dell’Associazione; la violazione delle regole di riservatezza e non pubblicità previste dallo Statuto; il mancato e ingiustificato pagamento della quota associativa; la condotta dell’associato che arrechi in qualunque modo danni morali o patrimoniali all’Associazione; il comportamento contrario alle regole della correttezza ed ogni condotta incompatibile con gli scopi e i valori di Base.</p>
              <p><strong>3.3</strong> Ai sensi dell’art. 24, ultimo comma, cod. civ., gli associati che abbiano receduto, siano stati esclusi o abbiano comunque cessato di appartenere all’Associazione non possono ripetere i contributi versati, né vantano alcun diritto sul patrimonio dell’Associazione.</p>
              <p><strong>3.4</strong> Contro la decisione del Consiglio Direttivo di Base che abbia deliberato l’esclusione, l’associato escluso ha diritto alla tutela giurisdizionale nei modi previsti dalla legge.</p>
            </section>

            <br></br>

            <section>
              <h2><strong>Art. 4 – Procedimento di deliberazione dell’esclusione</strong></h2>
              <p><strong>4.1</strong> L’esclusione è deliberata dal Consiglio Direttivo a maggioranza assoluta dei suoi componenti. Il Consiglio Direttivo decide senza obbligo di preavviso né in contraddittorio.</p>
              <p><strong>4.2</strong> L’esclusione di un associato è indicata nell’ordine del giorno della prima riunione utile del Consiglio Direttivo, se del caso appositamente convocata. L’esclusione può essere proposta dal Presidente dell’Associazione, da un componente del Consiglio Direttivo, da qualunque associato o anche da un terzo che abbia, per qualunque motivo, intrattenuto rapporti con l’Associazione.</p>
              <p><strong>4.3</strong> Per speciali ragioni di opportunità, il Consiglio Direttivo può deferire la decisione sull’esclusione di un associato all’Assemblea generale dei membri, che decide a maggioranza assoluta degli aventi diritto.</p>
              <p><strong>4.4</strong> Il Consiglio Direttivo decide senza l’intervento di altre parti. Prima della decisione ha facoltà di convocare, con qualsiasi modalità, l’associato della cui esclusione si discute, al fine di consentirgli di esporre le proprie difese.</p>
              <p><strong>4.5</strong> Il Consiglio Direttivo decide con deliberazione motivata. La motivazione contiene, anche in forma semplificata, tutti gli elementi posti a base della decisione, le ragioni per cui la violazione è ritenuta grave e per cui l’esclusione è considerata misura proporzionata. Ove la decisione sia assunta in contraddittorio, la motivazione tiene conto delle difese dell’associato.</p>
              <p><strong>4.6</strong> La deliberazione di esclusione è efficace, se non ne è disposta la sospensione, dal momento in cui è notificata al socio escluso.</p>
            </section>
            <section>
              <br></br>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Allegati</h2>
              <div className="flex flex-col sm:flex-row gap-4 mt-6">
                <a
                  href="/regolamento_AllegatoA.pdf"
                  download
                  className=""
                >
                  <Button variant="outline">
                    Scarica allegato A
                  </Button>
                </a>
                <a
                  href="/regolamento_AllegatoB.pdf"
                  download
                  className=""
                >
                  <Button variant="outline">
                    Scarica allegato B
                  </Button>
                </a>
              </div>
            </section>
          </p>
        </div>

        <Separator className="my-12" />

        {/* Application Button */}
        {!user && (
          !showForm ? (
            <div className="text-center py-8 sm:py-12">
              <Button
                onClick={() => setShowForm(true)}
                className="w-full sm:w-auto bg-black text-white hover:bg-gray-800 px-8 sm:px-12 py-4 sm:py-6 text-base sm:text-lg"
                data-testid="show-form-button"
              >
                Candidati ora
              </Button>
            </div>
          ) : (
            <div className="bg-gray-50 border border-gray-200 p-4 sm:p-6 md:p-8" data-testid="application-form">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8">Form di candidatura</h2>

            {!phoneVerified && (
              <div className="space-y-4 p-4 border border-gray-200 bg-white">
                <h3 className="font-semibold">Verifica numero di telefono</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <Label htmlFor="phone_prefix">Prefisso *</Label>
                    <Select
                      value={formData.phone_prefix}
                      onValueChange={(value) => {
                        setFormData((prev) => ({ ...prev, phone_prefix: value }));
                        setOtpSent(false);
                        setOtpCode('');
                        setBlockedMessage('');
                      }}
                    >
                      <SelectTrigger id="phone_prefix" data-testid="phone-prefix-select">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        {PHONE_PREFIXES.map((prefix) => (
                          <SelectItem key={prefix.code} value={prefix.code}>
                            <span className="flex items-center gap-2">
                              <span>{prefix.flag}</span>
                              <span>{prefix.code}</span>
                              <span className="text-gray-500 text-xs">({prefix.country})</span>
                            </span>
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  <div className="md:col-span-2">
                    <Label htmlFor="phone">Numero di telefono *</Label>
                    <Input
                      id="phone"
                      data-testid="phone-input"
                      required
                      value={formData.phone}
                      onChange={(e) => {
                        setFormData((prev) => ({ ...prev, phone: e.target.value }));
                        setOtpSent(false);
                        setOtpCode('');
                        setBlockedMessage('');
                      }}
                      placeholder="3331234567"
                    />
                  </div>
                </div>

                {!otpSent ? (
                  <Button
                    type="button"
                    onClick={handleSendOTP}
                    disabled={!formData.phone || sendingOtp}
                    data-testid="send-otp-button"
                  >
                    {sendingOtp ? 'Invio...' : 'Invia codice OTP'}
                  </Button>
                ) : (
                  <div className="space-y-2">
                    <Label htmlFor="otp">Codice OTP (6 cifre)</Label>
                    <div className="flex gap-2">
                      <Input
                        id="otp"
                        data-testid="otp-input"
                        type="text"
                        maxLength={6}
                        value={otpCode}
                        onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ''))}
                        placeholder="123456"
                      />
                      <Button
                        type="button"
                        onClick={handleVerifyOTP}
                        disabled={verifyingOtp || otpCode.length !== 6}
                        data-testid="verify-otp-button"
                      >
                        {verifyingOtp ? 'Verifica...' : 'Verifica'}
                      </Button>
                      <Button
                        type="button"
                        variant="outline"
                        onClick={handleSendOTP}
                        disabled={sendingOtp}
                        data-testid="resend-otp-button"
                      >
                        Invia di nuovo
                      </Button>
                    </div>
                  </div>
                )}

                {blockedMessage && (
                  <div className="p-3 border border-red-200 bg-red-50 text-red-700 text-sm rounded">
                    {blockedMessage}
                  </div>
                )}
              </div>
            )}

            {phoneVerified && (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="p-3 border border-green-200 bg-green-50 text-green-700 text-sm rounded">
                  Numero verificato: {formData.phone_prefix} {formData.phone}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <Label htmlFor="first_name">Nome *</Label>
                    <Input
                      id="first_name"
                      data-testid="first-name-input"
                      required
                      value={formData.first_name}
                      onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                    />
                  </div>
                  <div>
                    <Label htmlFor="last_name">Cognome *</Label>
                    <Input
                      id="last_name"
                      data-testid="last-name-input"
                      required
                      value={formData.last_name}
                      onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                    />
                  </div>
                </div>

                <div>
                  <Label htmlFor="email">Email *</Label>
                  <Input
                    id="email"
                    data-testid="email-input"
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => {
                      setFormData({ ...formData, email: e.target.value });
                      setEmailVerified(false);
                      setEmailOtpSent(false);
                      setEmailOtpCode('');
                      setEmailOtpId(null);
                    }}
                  />
                </div>

                <div className="space-y-3 p-4 border border-gray-200 rounded-md bg-gray-50">
                  <Label>Verifica email *</Label>
                  {!emailVerified && !emailOtpSent && (
                    <Button
                      type="button"
                      onClick={handleSendEmailOTP}
                      disabled={sendingEmailOtp || !formData.email}
                      className="w-full"
                    >
                      {sendingEmailOtp ? 'Invio in corso...' : 'Invia codice OTP via email'}
                    </Button>
                  )}

                  {emailOtpSent && !emailVerified && (
                    <div className="space-y-2">
                      <Label htmlFor="emailOtp">Inserisci il codice a 6 cifre ricevuto via email</Label>
                      <div className="flex gap-2">
                        <Input
                          id="emailOtp"
                          type="text"
                          maxLength={6}
                          value={emailOtpCode}
                          onChange={(e) => setEmailOtpCode(e.target.value.replace(/\D/g, ''))}
                          placeholder="000000"
                        />
                        <Button
                          type="button"
                          onClick={handleVerifyEmailOTP}
                          disabled={verifyingEmailOtp || emailOtpCode.length !== 6}
                        >
                          {verifyingEmailOtp ? 'Verifica...' : 'Verifica'}
                        </Button>
                      </div>
                      <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        onClick={handleSendEmailOTP}
                        disabled={sendingEmailOtp}
                      >
                        Invia di nuovo
                      </Button>
                    </div>
                  )}

                  {emailVerified && (
                    <div className="flex items-center gap-2 text-green-600">
                      <span className="text-2xl">✓</span>
                      <span className="font-medium">Email verificata</span>
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="country">Nazione *</Label>
                    <Select
                      value={formData.country_id?.toString() || ''}
                      onValueChange={(value) => handleCountryChange(value)}
                    >
                      <SelectTrigger id="country" data-testid="country-select">
                        <SelectValue placeholder="Seleziona nazione..." />
                      </SelectTrigger>
                      <SelectContent>
                        {countries.map((country) => (
                          <SelectItem key={country.id} value={country.id.toString()}>
                            {country.name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>

                  <div>
                    <Label htmlFor="city_strgin">Città *</Label>
                    <Input
                      id="city_strgin"
                      data-testid="city-string-input"
                      required
                      value={formData.city_strgin}
                      onChange={(e) => setFormData({ ...formData, city_strgin: e.target.value })}
                      placeholder="Inserisci città"
                    />
                  </div>
                </div>

                <div className="p-4 bg-gray-50 border border-gray-200 space-y-4">
                  <h3 className="font-semibold text-lg">Posizione attuale – ambito professionale o formativo</h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Label htmlFor="company_name">Azienda / Università *</Label>
                      <Input
                        id="company_name"
                        data-testid="company-name-input"
                        value={formData.company_name}
                        onChange={(e) => setFormData({ ...formData, company_name: e.target.value })}
                        placeholder="es. Microsoft"
                      />
                    </div>

                    <div>
                      <Label htmlFor="job_title">Ruolo / Percorso formativo *</Label>
                      <Input
                        id="job_title"
                        data-testid="job-title-input"
                        value={formData.job_title}
                        onChange={(e) => setFormData({ ...formData, job_title: e.target.value })}
                        placeholder="es. Senior Developer"
                      />
                    </div>
                  </div>

                  <div>
                    <Label htmlFor="job_category">Categoria posizione ricoperta *</Label>
                    <Select
                      value={formData.job_category_id?.toString() || ''}
                      onValueChange={(value) => setFormData({ ...formData, job_category_id: parseNumericValue(value) })}
                    >
                      <SelectTrigger id="job_category" data-testid="job-category-select">
                        <SelectValue placeholder="Seleziona categoria..." />
                      </SelectTrigger>
                      <SelectContent>
                        {jobCategories.map((category) => (
                          <SelectItem key={category.id} value={category.id.toString()}>
                            {category.name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>

                  <div>
                    <Label htmlFor="company_sector">Settore Azienda / Area di riferimento formativa *</Label>
                    <Select
                      value={formData.company_sector_id?.toString() || ''}
                      onValueChange={(value) => setFormData({ ...formData, company_sector_id: parseNumericValue(value) })}
                    >
                      <SelectTrigger id="company_sector" data-testid="company-sector-select">
                        <SelectValue placeholder="Seleziona settore..." />
                      </SelectTrigger>
                      <SelectContent>
                        {companySectors.map((sector) => (
                          <SelectItem key={sector.id} value={sector.id.toString()}>
                            {sector.name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                </div>

                <div>
                  <Label htmlFor="utente_invitato_da">Utente invitato da *</Label>
                  <Input
                    id="utente_invitato_da"
                    data-testid="invited-by-input"
                    required
                    value={formData.utente_invitato_da}
                    onChange={(e) => setFormData({ ...formData, utente_invitato_da: e.target.value })}
                    placeholder="Nome e cognome del referente"
                  />
                </div>

                <div>
                  <Label htmlFor="linkedin_url">Link profilo LinkedIn (facoltativo)</Label>
                  <Input
                    id="linkedin_url"
                    data-testid="linkedin-url-input"
                    type="url"
                    value={formData.linkedin_url}
                    onChange={(e) => {
                      setFormData({ ...formData, linkedin_url: e.target.value });
                      validateLinkedInUrl(e.target.value);
                    }}
                    placeholder="https://linkedin.com/in/nomeutente"
                    className={linkedinError ? 'border-red-500' : ''}
                  />
                  {linkedinError && (
                    <p className="text-red-500 text-sm mt-1" data-testid="linkedin-error">{linkedinError}</p>
                  )}
                  <p className="text-xs text-gray-600 mt-1">
                    Formato valido: https://linkedin.com/in/nomeutente o https://linkedin.com/company/nomeazienda
                  </p>
                </div>

                <div>
                  <Label htmlFor="cv">CV (PDF, DOC, DOCX) *</Label>
                  <Input
                    id="cv"
                    data-testid="cv-input"
                    type="file"
                    required
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => setCv(e.target.files[0])}
                  />
                </div>

                <div>
                  <Label htmlFor="motivation_letter">Lettera motivazionale (PDF, DOC, DOCX) *</Label>
                  <Input
                    id="motivation_letter"
                    data-testid="motivation-letter-input"
                    type="file"
                    required
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => setMotivationLetter(e.target.files[0])}
                  />
                </div>

                <div>
                  <Label htmlFor="profile_photo">Foto profilo *</Label>
                  <Input
                    id="profile_photo"
                    data-testid="profile-photo-input"
                    type="file"
                    accept="image/*"
                    onChange={handleProfilePhotoInputChange}
                  />
                  <p className="text-xs text-gray-600 mt-1">
                    Formati supportati: JPG, PNG, WEBP, GIF. Dopo la selezione potrai ritagliare la foto.
                  </p>
                  {profilePhoto && (
                    <div className="mt-2 flex items-center gap-3">
                      {profilePhotoPreviewUrl && (
                        <img
                          src={profilePhotoPreviewUrl}
                          alt="Anteprima foto profilo"
                          className="h-16 w-16 rounded-full object-cover border"
                        />
                      )}
                      <p className="text-xs text-green-700">
                        Foto pronta: {profilePhoto.name}
                      </p>
                    </div>
                  )}
                </div>

                <div className="flex items-start gap-3 p-4 bg-white border border-gray-200">
                  <Checkbox
                    id="documents_accepted"
                    data-testid="documents-accepted-checkbox"
                    checked={formData.documents_accepted}
                    onCheckedChange={(checked) => setFormData({ ...formData, documents_accepted: CHECKBOX_TO_BOOL(checked) })}
                  />
                  <Label htmlFor="documents_accepted" className="text-sm leading-relaxed cursor-pointer">
                    Dichiaro di aver letto e accettato lo Statuto, il Codice Etico e il Regolamento di ammissione/esclusione dell'Associazione *
                  </Label>
                </div>

                <div className="flex items-start gap-3 p-4 bg-white border border-gray-200">
                  <Checkbox
                    id="privacy_accepted"
                    data-testid="privacy-accepted-checkbox"
                    checked={formData.privacy_accepted || false}
                    onCheckedChange={(checked) => setFormData({ ...formData, privacy_accepted: CHECKBOX_TO_BOOL(checked) })}
                  />
                  <Label htmlFor="privacy_accepted" className="text-sm leading-relaxed cursor-pointer">
                    Inviando la candidatura dichiaro di aver letto l&apos;{' '}
                    <a
                      href="/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 underline"
                    >
                      Informativa Privacy
                    </a> *
                  </Label>
                </div>

                <div className="flex gap-4">
                  <Button
                    type="submit"
                    disabled={submitting}
                    className="bg-black text-white hover:bg-gray-800 px-8 disabled:opacity-50 disabled:cursor-not-allowed"
                    data-testid="submit-application-button"
                  >
                    {submitting ? 'Invio...' : 'Invia candidatura'}
                  </Button>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => {
                      resetFormState();
                      setShowForm(false);
                    }}
                    className="border-2 border-black hover:bg-black hover:text-white"
                    data-testid="cancel-button"
                  >
                    Annulla
                  </Button>
                </div>
              </form>
            )}
            </div>
          )
        )}
      </div>
      <ProfilePhotoCropModal
        open={cropModalOpen}
        onOpenChange={(open) => {
          setCropModalOpen(open);
          if (!open) {
            setRawProfilePhotoFile(null);
          }
        }}
        file={rawProfilePhotoFile}
        onConfirm={handleProfilePhotoCropConfirm}
      />
    </div>
  );
}
